import React, { FC } from 'react';
import { CardDescription, CardList, CardListItem, CardListItemText, Discount, NoDiscount, Pricing } from './styled';
import { useTranslation } from 'react-i18next';
import { Icon } from 'kl-b2c-ui-kit';

interface RegistrationPricingProps {
    noMargin?: boolean;
}

const RegistrationPricing: FC<RegistrationPricingProps> = ({ noMargin }) => {
    const { t } = useTranslation('pages/home');

    return (
        <>
            <CardDescription margin={24}>{t('attendee-includes')}</CardDescription>
            <CardList>
                <CardListItem>
                    <Icon name={'Check'} size={20} color={'primary'} />
                    <CardListItemText>
                        {t('opp-list-1')}
                        <br />
                        <span>{t('opp-list-1-desc')}</span>
                    </CardListItemText>
                </CardListItem>
                <CardListItem>
                    <Icon name={'Check'} size={20} color={'primary'} />
                    <CardListItemText>{t('opp-list-2')}</CardListItemText>
                </CardListItem>
                <CardListItem>
                    <Icon name={'Check'} size={20} color={'primary'} />
                    <CardListItemText>{t('opp-list-3')}</CardListItemText>
                </CardListItem>
                <CardListItem>
                    <Icon name={'Check'} size={20} color={'primary'} />
                    <CardListItemText>{t('opp-list-4')}</CardListItemText>
                </CardListItem>
                <CardListItem>
                    <Icon name={'Check'} size={20} color={'primary'} />
                    <CardListItemText>{t('opp-list-5')}</CardListItemText>
                </CardListItem>
                <CardListItem>
                    <Icon name={'Check'} size={20} color={'primary'} />
                    <CardListItemText>
                        {t('opp-list-6')}
                        <br />
                        <span>{t('opp-list-5-desc')}</span>
                    </CardListItemText>
                </CardListItem>
            </CardList>
            <Pricing noMargin={noMargin}>
                <Discount>{t('opp-no-discount')}</Discount>
                {/* <Discount>{t('opp-discount1')}</Discount> */}
                {/* <NoDiscount>{t('opp-no-discount')}</NoDiscount> */}
                {/* <CardListItemText>
                    <span>{t('opp-discount-desc1')}</span>
                </CardListItemText> */}
            </Pricing>
        </>
    );
};

export default RegistrationPricing;
